
import React from 'react';
import { Bot, X } from 'lucide-react';
import { useAIAgent } from '../../context/AIAgentContext';

const AIAgentToggle = () => {
  const { isAgentActive, toggleAgent } = useAIAgent();

  return (
    <div className="fixed left-4 bottom-4 z-50">
      <button
        onClick={toggleAgent}
        className={`flex items-center justify-center w-12 h-12 rounded-full shadow-lg transition-all ${
          isAgentActive ? 'bg-purple-700 text-white' : 'bg-white text-purple-700 border border-purple-200'
        }`}
        aria-label={isAgentActive ? "Close Fuel AI Agent" : "Open Fuel AI Agent"}
      >
        {isAgentActive ? <X size={20} /> : <Bot size={20} />}
      </button>
    </div>
  );
};

export default AIAgentToggle;
